module.exports = __webpack_public_path__ + "img/snn.074f985f.jpg";